import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { Color, theme } from '../../../../constants'
import { Clickable, Flex, Icon, IconProps, Text } from '../../../../elements'
import { Cell } from '../components/Cell'
import { HEADER_HEIGHT, composableZIndex } from '../consts'
import { useGroup, useSchedule } from '../useSchedule'

const X_PADDING = theme.spacing[3]

const TitleRow = styled.tr({
  position: 'sticky',
  top: HEADER_HEIGHT,
  zIndex: composableZIndex.head,
})

const Body = styled(Flex)({
  padding: `${theme.spacing[2]}px ${X_PADDING}px`,
  width: '100%',
})

type GroupProps = {
  title: string
  id: string
  isTeam?: boolean
  skipGroup?: boolean
  hideGroup?: boolean
  children?: ReactNode
  slot?: ReactNode
  iconProps?: IconProps
}

export const Group = (props: GroupProps) => {
  const { columnCount } = useSchedule()
  const { isOpen, toggleOpen } = useGroup(props.id)

  if (props.hideGroup) {
    return null
  }

  if (props.skipGroup) {
    return props.children
  }

  return (
    <>
      <TitleRow>
        <Cell
          style={{ padding: 0, borderBottom: theme.border.style.thinLight }}
          colSpan={columnCount}
          isTitle
        >
          <Body
            style={{
              background: props.isTeam ? Color.GREY : Color.BACKGROUND_GREY,
            }}
          >
            <Clickable
              onClick={toggleOpen}
              styles={{
                display: 'flex',
                gap: 2,
                width: 'fit-content',
                alignItems: 'center',
                position: 'sticky',
                left: X_PADDING,
              }}
            >
              <Icon name={isOpen ? 'ChevronDownIcon' : 'ChevronRightIcon'} />
              <Text>{props.title}</Text>
              {props.slot}
            </Clickable>
          </Body>
        </Cell>
      </TitleRow>
      {isOpen && props.children}
    </>
  )
}
